import { observable, action } from 'mobx';
export default class EligibilityDataStore {
    @observable EligibilityData: any[] = observable([]);
    @observable TotalPages: number = 1;
    @observable CurrentPage: number = 0;
}
